(function () {
var $04af1a4997f8ee6a$var$elements = document.querySelectorAll('[data-animate]');
if ($04af1a4997f8ee6a$var$elements.length) {
    var $04af1a4997f8ee6a$var$observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            $04af1a4997f8ee6a$var$observer.unobserve(entry.target);
        });
    }, {
        threshold: 0.08,
        rootMargin: '0px 0px -40px 0px'
    });
    $04af1a4997f8ee6a$var$elements.forEach(function(el) {
        var _el_getBoundingClientRect = el.getBoundingClientRect(), top = _el_getBoundingClientRect.top, bottom = _el_getBoundingClientRect.bottom;
        if (top < window.innerHeight && bottom > 0) requestAnimationFrame(function() {
            return el.classList.add('is-visible');
        });
        else $04af1a4997f8ee6a$var$observer.observe(el);
    });
}

})();
//# sourceMappingURL=scroll-reveal.js.map
